import { UserCircleIcon } from "@octopusdeploy/design-system-icons";
import type { TenantResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { MissingChip, TenantChip, ChipIcon } from "~/components/Chips";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { SelectItem } from "~/components/VirtualListWithKeyboard/SelectItem";
import type { FormFieldProps } from "~/components/form";
import { ChipIconWrapper } from "../Chips/ChipIconWrapper";
import FrozenDashboardIcon from "../DeploymentFreezes/FrozenDashboardIcon";
import { FrozenResourceType } from "../DeploymentFreezes/FrozenIcon";
import Lookup from "../Lookup";
interface TenantMultiSelectProps extends FormFieldProps<string[]> {
    items: {
        Id: string;
        Name: string;
        IsDisabled?: boolean | null;
        IsFrozen?: boolean | null;
    }[];
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
    disableCloseOnSelected?: boolean;
}
const TenantTypedMultiSelect = MultiSelect<{
    Id: string;
    Name: string;
    IsDisabled?: boolean | null;
    IsFrozen?: boolean | null;
}>();
export const TenantMultiSelect: React.FC<TenantMultiSelectProps> = (props) => {
    const chipRenderer = (r: TenantResource | SelectItem, onRequestDelete: () => void) => {
        return (<Lookup lookupCollection={props.items} lookupId={r.Id} getIdFromElement={(element) => element.Id} render={(item) => (<TenantChip onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Delete ${item.Name}`} tenantName={item.Name} isDisabled={!!item.IsDisabled} icon={item.IsFrozen ? (<FrozenDashboardIcon for={FrozenResourceType.Tenant}/>) : (<ChipIconWrapper>
                                    <UserCircleIcon size={16}/>
                                </ChipIconWrapper>)}/>)} renderFallback={<MissingChip lookupId={r.Id} type={ChipIcon.Tenant} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete}/>}/>);
    };
    return (<TenantTypedMultiSelect fieldName="tenants" renderChip={chipRenderer} renderItem={(item) => {
            return {
                primaryText: (<div>
                            {item.Name}
                            {item.IsFrozen && <FrozenDashboardIcon for={FrozenResourceType.Tenant}/>}
                        </div>),
                secondaryText: item.IsDisabled ? "Disabled" : "",
            };
        }} disableCloseOnSelected={props.disableCloseOnSelected} {...props}/>);
};
TenantMultiSelect.displayName = "TenantMultiSelect"
